module.exports = __webpack_public_path__ + "static/media/stayoversIcon.589a3aea.svg";